export default __webpack_public_path__ + "images/NZ.fec26b5.png";